import { gql, useMutation } from '@apollo/client';
import { useToast } from '@chakra-ui/react';
import * as React from 'react';

import { logError } from '@/imports/logging/ClientLogger';

import { usePrepareUserCsv_PrepUserCsvUpload } from './graphql-types/usePrepareUserCsv_PrepUserCsvUpload';

const PREP_USER_CSV_UPLOAD_MUTATION = gql`
  mutation usePrepareUserCsv_PrepUserCsvUpload {
    prepUserCsvUpload {
      presignedS3Url
      csvUploadId
      metadataHeaders {
        name
        value
      }
    }
  }
`;

export const usePrepareUserCsv = (): {
  prepareUserCsv: () => Promise<void>;
  prepareUserCsvData: usePrepareUserCsv_PrepUserCsvUpload | null | undefined;
  prepareUserCsvLoading: boolean;
  clearCsvResult: () => void;
} => {
  const toast = useToast();

  const [
    prepareUserCsv,
    { loading: prepareMutationLoading, data: userCsvPrepMutationData },
  ] = useMutation<usePrepareUserCsv_PrepUserCsvUpload>(
    PREP_USER_CSV_UPLOAD_MUTATION
  );

  const [csvPrepped, setCsvPrepped] = React.useState(false);

  const prepareUserCsvData = csvPrepped ? userCsvPrepMutationData : undefined;

  React.useEffect(() => {
    if (!!userCsvPrepMutationData) {
      setCsvPrepped(true);
    }
  }, [userCsvPrepMutationData]);

  const handlePrepUserCsvUpload = async (): Promise<void> => {
    try {
      await prepareUserCsv();
    } catch (err) {
      toast({
        title: 'Failed to prepare the csv upload. Please try again.',
        status: 'error',
      });
      logError(err);
    }
  };

  return {
    prepareUserCsv: handlePrepUserCsvUpload,
    prepareUserCsvData,
    prepareUserCsvLoading: prepareMutationLoading,
    clearCsvResult: () => setCsvPrepped(false),
  };
};
